/* Vitafin scroll-reveal — one shared IntersectionObserver.
   Elements opt in with data-vf-reveal (+ style="--vf-i:N" for stagger).
   Idempotent, reduced-motion-safe, re-hooks on theme-editor section loads.
   CSS lives in assets/vf-base.css. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function io() {
    if (window.__vfIO) return window.__vfIO;
    if (reduce || !('IntersectionObserver' in window)) return null;
    window.__vfIO = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('vf-in');
            window.__vfIO.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );
    return window.__vfIO;
  }
  window.vfReveal = function (root) {
    var o = io();
    (root || document).querySelectorAll('[data-vf-reveal]:not(.vf-in)').forEach(function (el) {
      if (o) {
        o.observe(el);
      } else {
        el.classList.add('vf-in');
      }
    });
  };
  window.vfReveal(document);
  document.addEventListener('DOMContentLoaded', function () {
    window.vfReveal(document);
  });
  document.addEventListener('shopify:section:load', function (e) {
    window.vfReveal(e.target);
  });
})();
